import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem } from '../mem/filesMem'

apiRegistry.registerGetApi('searchFiles', async (request) => {
  const { query, parentId } = request

  if (!query.trim()) {
    return { files: [], totalCount: 0 }
  }

  const searchTerm = query.toLowerCase().trim()
  let allFiles = Object.values(filesMem)

  // Filter by parent if specified
  if (parentId) {
    const parentPath = filesMem[parentId]?.path || '/'
    allFiles = allFiles.filter(file =>
      file.path.startsWith(parentPath + '/') || file.parentId === parentId
    )
  }

  // Search by name (case-insensitive)
  const matchingFiles = allFiles.filter(file =>
    file.name.toLowerCase().includes(searchTerm)
  )

  // Sort by relevance (exact matches first, then partial matches)
  const sortedFiles = matchingFiles.sort((a, b) => {
    const aNameLower = a.name.toLowerCase()
    const bNameLower = b.name.toLowerCase()

    // Exact matches first
    if (aNameLower === searchTerm && bNameLower !== searchTerm) return -1
    if (bNameLower === searchTerm && aNameLower !== searchTerm) return 1

    // Then by name alphabetically
    return aNameLower.localeCompare(bNameLower)
  })

  return {
    files: sortedFiles,
    totalCount: sortedFiles.length
  }
})